import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';

import { ApiStatus } from 'common/enums';
import { IErrorResponse } from 'common/models/api-service/error-response.model';

import {
    CompanyInfoDTO,
    LocationDetails,
    UpdateCompanyInfoPayload,
    UpdateFootprintPayload
} from '../models/data-management.model';
import { PaginatedApiResponse } from 'common/models/api-service/api-response.model';
import { PagedRequest } from 'common/models/data/pagedRequest.model';
import initialDataManagementState from './data-management.state';

const dataManagementSlice = createSlice({
    name: 'dataManagementSlice',
    initialState: initialDataManagementState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchCompanyFootprint: (state, { payload }: PayloadAction<PagedRequest>) => {
            state.companyFootprints.status = ApiStatus.LOADING;
        },
        fetchCompanyFootprintSuccess: (
            state,
            { payload }: PayloadAction<PaginatedApiResponse<LocationDetails[]>>
        ) => {
            state.companyFootprints.status = ApiStatus.SUCCESS;
            if (payload.pagination.currentPage === 1) {
                state.companyFootprints.data = payload;
            } else {
                if (
                    state.companyFootprints.data &&
                    state.companyFootprints.data.data &&
                    state.companyFootprints.data.data.length > 0 &&
                    payload.data &&
                    payload.data.length > 0
                ) {
                    let updatedData = [...current(state.companyFootprints.data.data)];
                    updatedData = updatedData.concat([...payload.data]);
                    state.companyFootprints.data.data = updatedData;
                    state.companyFootprints.data.pagination = payload.pagination;
                }
            }
        },
        fetchCompanyFootprintFailed: (state, { payload }) => {
            state.companyFootprints.status = ApiStatus.ERROR;
            state.companyFootprints.error = payload;
        },
        updateCompanyFootprint: (
            state,
            {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                payload
            }: PayloadAction<UpdateFootprintPayload>
        ) => {
            state.updateCompanyFootprint.status = ApiStatus.LOADING;
        },
        updateCompanyFootprintSuccess: (state, { payload }: PayloadAction<LocationDetails>) => {
            state.updateCompanyFootprint.status = ApiStatus.SUCCESS;
            state.updateCompanyFootprint.data = payload;
            if (
                state.companyFootprints?.data?.data &&
                state.companyFootprints?.data?.data.length > 0
            ) {
                const updatedFootprintData = current(state.companyFootprints.data.data).map(
                    (footprint) => {
                        if (footprint.userCompanyLocationId === payload.userCompanyLocationId) {
                            return { ...footprint, isEYPresence: payload.isEYPresence };
                        }
                        return footprint;
                    }
                );
                state.companyFootprints.data = {
                    ...state.companyFootprints.data,
                    data: updatedFootprintData
                };
            }
        },
        updateCompanyFootprintFailed: (state, { payload }: PayloadAction<IErrorResponse>) => {
            state.updateCompanyFootprint.status = ApiStatus.ERROR;
            state.updateCompanyFootprint.error = payload;
        },
        fetchCompanyInfo: (state) => {
            state.companyInfo.status = ApiStatus.LOADING;
        },
        fetchCompanyInfoSuccess: (state, { payload }: PayloadAction<CompanyInfoDTO>) => {
            state.companyInfo.status = ApiStatus.SUCCESS;
            state.companyInfo.data = payload;
        },
        fetchCompanyInfoFailed: (state, { payload }: PayloadAction<IErrorResponse>) => {
            state.updateCompanyInfo.status = ApiStatus.ERROR;
            state.updateCompanyInfo.error = payload;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateCompanyInfo: (state, { payload }: PayloadAction<UpdateCompanyInfoPayload>) => {
            state.updateCompanyInfo.status = ApiStatus.LOADING;
        },
        updateCompanyInfoSuccess: (state, { payload }: PayloadAction<CompanyInfoDTO>) => {
            state.updateCompanyInfo.status = ApiStatus.SUCCESS;
            state.updateCompanyInfo.data = payload;
        },
        updateCompanyInfoFailed: (state, { payload }: PayloadAction<IErrorResponse>) => {
            state.updateCompanyInfo.status = ApiStatus.ERROR;
            state.updateCompanyInfo.error = payload;
        },
        resetCompanyFootprintEditResponse: (state) => {
            state.updateCompanyFootprint = {};
        },
        resetCompanyInfoEditResponse: (state) => {
            state.updateCompanyInfo = {};
        }
    }
});

export default dataManagementSlice.reducer;
export const dataManagementActions = dataManagementSlice.actions;
